'use client';

import { useRef } from 'react';
import { useAuthStore, useHydrateAuthSession } from '@/entities/auth';

export default function AuthProvider({
  children,
  initialIsAuthenticated,
}: {
  children: React.ReactNode;
  /** SSR 에서 세션 쿠키 존재 여부로 결정된 초기 인증 상태. 헤더 깜빡임 방지용 seed. */
  initialIsAuthenticated: boolean;
}) {
  // mount 시 1회 store 를 SSR hint 로 seed. useEffect 가 아닌 ref 가드 + 즉시 호출이라
  // 첫 render 결과 자체가 hydrated 상태로 노출됨.
  const hydratedRef = useRef(false);
  if (!hydratedRef.current) {
    useAuthStore.getState().hydrate(initialIsAuthenticated);
    hydratedRef.current = true;
  }

  // 쿠키가 없으면 비로그인이 확정이므로 /user fetch 자체를 스킵.
  useHydrateAuthSession({ enabled: initialIsAuthenticated });

  return <>{children}</>;
}
